import { render, staticRenderFns } from "./wrongCard.vue?vue&type=template&id=42d50cef&scoped=true&"
import script from "./wrongCard.vue?vue&type=script&lang=js&"
export * from "./wrongCard.vue?vue&type=script&lang=js&"
import style0 from "./wrongCard.vue?vue&type=style&index=0&id=42d50cef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d50cef",
  null
  
)

export default component.exports